export default __webpack_public_path__ + "static/media/p2023-37.ff74313a.jpeg";